import { useParams } from 'react-router-dom'

export const useTokenReport = () => {
  const { token } = useParams()
  return { token }
}
